// Missing several props and methods from core implementation

import React from 'react';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimarySummaryEditor } from '@bibliocommons/shared-ugc-editors';
import { currentUserSelector } from '../../selectors/AuthSelector';

class PrimarySummaryEditorContainer extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      showForm: true,
      initialSummary: '',
      summary: '',
      isNew: true,
      bibId: props.bibId,
      isPrivate: false,
      userContentId: null,
      expanded: false,
      initializingStatus: {
        status: 'success',
        localeKey: null
      },
      user: props.user
    };

    this.bindAll('handleChange');
  }

  static handleLogin(e) {
    e.preventDefault();
  }

  static handleSubmit(e) {
    e.preventDefault();
  }

  handleChange(value) {
    this.setState({
      summary: value,
      isEmpty: value.length <= 0
    });
  }

  static handlePrivacyToggle() {

  }

  render() {
    return (
      <PrimarySummaryEditor
        characterLimit={4000}
        summary={this.state.summary}
        handleLogin={PrimarySummaryEditorContainer.handleLogin}
        handleChange={this.handleChange}
        isNew={this.state.isNew}
        showForm={this.state.showForm}
        handleSubmit={PrimarySummaryEditorContainer.handleSubmit}
        handlePrivacyToggle={PrimarySummaryEditorContainer.handlePrivacyToggle}
        bibId={this.state.bibId}
        isPrivate={this.props.isPrivate}
        isEmpty={this.state.isEmpty}
        metadataId={this.props.metadataId}
        user={this.state.user}
        userContentId={this.state.userContentId}
        initializingStatus={this.state.initializingStatus} />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const user = currentUserSelector(state);
  const editorUser = user ? {
    loggedIn: true,
    id: user.id,
    // idHash: '',
    allowFreeText: true
  } : { loggedIn: false };

  return {
    bibId: ownProps.bibId,
    metadataId: ownProps.metadataId,
    user: editorUser
  };
};

export default connect(mapStateToProps)(PrimarySummaryEditorContainer);



// WEBPACK FOOTER //
// ./app/containers/UGCTestContainers/PrimarySummaryEditorContainer.jsx